magna.cart = async event => {
  const id = event.target.id
  event.target.parentElement.classList.add('cart__item-fade')

  const url = '/cart/change.js'
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, quantity: 0 }),
    })

    if (!response.ok) {
      throw new Error('There was a problem with the request')
    }

    const json = await response.json()
    event.target.parentElement.classList.add('cart__item-collapse')
  } catch (e) {
    console.error(e.message)
    return null
  } finally {
    window.location.reload()
  }
}

subscribe(Event.domready, () => {
  document
    .querySelectorAll('.cart__remove')
    .forEach(item => item.addEventListener('click', magna.cart))
})
